module.exports = __webpack_public_path__ + "img/phone-icon.cc486702.svg";